import React from "react";
import { useParams, Link } from 'react-router-dom';

const AllTeams = (props) => {

    const { organization_id } = useParams();

    return (
        <div className="teams-wrap">

            <h3 className="mb-4">Alla Teams</h3>

            { props.teams &&
                <div className="row">

                    { props.teams.map( (team, index) => {

                        const teamUsers = JSON.parse( team?.team_users );
                        const allColors = ['primary', 'halite-blue', 'sy-gray', 'sy-bronze'];

                        const random = Math.floor(Math.random() * allColors.length);

                        return (
                            <div className="col-12 col-lg-4 mb-4" key={index}>
                                <div className="team-inner bg-white shadow-sm">
                                    <div className={`team-name-wrap bg-${allColors[random]} text-white px-3 py-4 d-flex align-items-center justify-content-center`} style={{ minHeight: "140px" }}>
                                        <h4>{team?.team_name}</h4>
                                    </div>
                                    <div className="team-content-wrap my-3 px-3 text-center">
                                        <h5>{ teamUsers ? teamUsers.length : 0 } Medlemmar</h5>
                                    </div>
                                    <div className="d-inline-block w-100 text-center py-4">
                                        <Link to={`/organizations/${organization_id}/teams/${team?.ID}`} className="btn btn-secondary rounded-pill">
                                            <span className="me-2">Visa</span>
                                            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )
                    }) }

                </div>
            }

        </div>
    )

}

export default AllTeams;